import * as React from 'react';
import {connect} from 'react-redux';
import {WithStyles, withStyles} from '@material-ui/core';
import {IEvent} from '@app-types/websocket/event.types';
import {IFamilyMember} from '@app-types/websocket/family.types';
import EditEventDialog from '@components/calendar2/eventdetails/EditEventDialog';
import * as EventActions from '@services/events/event.action';
import TranslateNew from '@translate/TranslateNew';
import TodoListRow from './TodoListRow';
import {TodoListStyle} from './TodoList.style';
import {calendarEventAsTodo, getCalendarTodos} from './calendarTodoItems';
import {useCalendarTodoDate} from './useCalendarTodoDate';

const tn = TranslateNew.getInstance();

interface IProps extends WithStyles<typeof TodoListStyle> {
  events: IEvent[];
  family: IFamilyMember[];
  myAccountId: number;
  active: boolean;
  emptyContent?: React.ReactNode;
  seenEvent: (id: number) => void;
  completedEvent: (id: number) => void;
}

export const CalendarTodos = (props: IProps) => {
  const now = useCalendarTodoDate(props.active);
  const [editingId, setEditingId] = React.useState<number | undefined>(undefined);
  const events = getCalendarTodos(props.events, now);
  const editingEvent = props.events.find(event => event.id === editingId);

  return (
    <>
      {events.length > 0 ? (
        <section className={props.classes.calendarSection} aria-labelledby="calendar-todos-info">
          <hr className={props.classes.calendarDivider} />
          <p className={props.classes.calendarInfo} id="calendar-todos-info">{tn.lang.todoCalendarInfo}</p>
          {events.map(event => {
            const start = new Date(event.startTime);
            return (
              <TodoListRow key={event.id} source="calendar" todo={calendarEventAsTodo(event)}
                family={props.family} myAccountId={props.myAccountId}
                seen={!!event.seen && event.seen.includes(props.myAccountId)}
                active={props.active && !editingEvent}
                markSeen={() => props.seenEvent(event.id)}
                readRevision={JSON.stringify([event.id, event.title, event.description, event.startTime,
                  event.endTime, event.hasTime, event.tagged, event.visible, event.checkmark, event.completedBy, event.file])}
                due={start} dateLabel={tn.formatDateMonthShort(start)}
                edit={() => setEditingId(event.id)}
                complete={() => props.completedEvent(event.id)} />
            );
          })}
        </section>
      ) : props.emptyContent}
      {editingEvent && <EditEventDialog open={true} event={editingEvent} close={() => setEditingId(undefined)} />}
    </>
  );
};

const mapStateToProps = (state: any) => ({
  events: state.event && state.event.events ? state.event.events : [],
});

export default connect(mapStateToProps, {
  seenEvent: EventActions.seenEvent,
  completedEvent: EventActions.completedEvent,
})(withStyles(TodoListStyle)(CalendarTodos));



// WEBPACK FOOTER //
// ./src/components/todo/CalendarTodos.tsx